export enum PaymentStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
  AUTHORIZED = 'AUTHORIZED',
  CAPTURE_REQUESTED = 'CAPTURE_REQUESTED',
}
